import { Badge, Button, SelectMenu, type SelectOption } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { selectOptionsOf } from '../fieldTypeMeta';

/**
 * The listbox shows each option as its Badge, so the colour a user picks here is
 * the colour they will see in the table and on the board. The stored value is the
 * option ID.
 */
export function SelectInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  const options: readonly SelectOption[] = selectOptionsOf(field).map((option) => ({
    value: option.id,
    label: option.label,
    render: <Badge tone={option.color ?? 'neutral'}>{option.label}</Badge>,
  }));

  return (
    <div className="flex items-center gap-2">
      <SelectMenu
        value={typeof value === 'string' && value.length > 0 ? value : undefined}
        onValueChange={onChange}
        options={options}
        disabled={readOnly}
        ariaLabel={field.label}
        placeholder="Select an option"
      />
      {/* Radix Select has no empty value, so clearing is its own control rather
          than a fake "none" option that could be stored by accident. */}
      {!field.isRequired && typeof value === 'string' && value.length > 0 && (
        <Button variant="ghost" size="sm" onClick={() => onChange(null)} disabled={readOnly}>
          Clear
        </Button>
      )}
    </div>
  );
}
